import React from 'react';
import {
  Container,
  Heading,
  Box,
  SimpleGrid,
  Text,
  Card,
  CardHeader,
  CardBody,
  VStack,
  HStack,
  Badge,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
} from '@chakra-ui/react';
import { propertyData } from '../data/dummyData';

function Details() {
  return (
    <Box bg='gray.50' minH='100vh'>
      <Container maxW='container.xl' py={8}>
        <VStack spacing={8} align='stretch'>
          <Box>
            <Heading size='lg' mb={2}>
              {propertyData.address}
            </Heading>
            <Text color='gray.600'>Detailed Property Information</Text>
          </Box>

          {/* Property Details */}
          <Card variant='outline'>
            <CardHeader>
              <Heading size='md'>Property Details</Heading>
            </CardHeader>
            <CardBody>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
                <Box>
                  <VStack align='stretch' spacing={4}>
                    <HStack justify='space-between'>
                      <Text>Floor Area</Text>
                      <Badge colorScheme='blue' fontSize='md'>
                        {propertyData.myHome.propertyDetails.floorArea}
                      </Badge>
                    </HStack>
                    <HStack justify='space-between'>
                      <Text>Habitable Rooms</Text>
                      <Badge colorScheme='blue' fontSize='md'>
                        {propertyData.myHome.propertyDetails.habitableRooms}
                      </Badge>
                    </HStack>
                  </VStack>
                </Box>
                <Box>
                  <VStack align='stretch' spacing={4}>
                    <HStack justify='space-between'>
                      <Text>Main Fuel</Text>
                      <Badge colorScheme='green' fontSize='md'>
                        {propertyData.myHome.propertyDetails.mainFuel}
                      </Badge>
                    </HStack>
                    <HStack justify='space-between'>
                      <Text>Extensions</Text>
                      <Badge colorScheme='purple' fontSize='md'>
                        {propertyData.myHome.propertyDetails.extensions}
                      </Badge>
                    </HStack>
                  </VStack>
                </Box>
              </SimpleGrid>
            </CardBody>
          </Card>

          {/* Energy and Council Tax */}
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
            <Card variant='outline'>
              <CardHeader>
                <Heading size='md'>Energy Efficiency</Heading>
              </CardHeader>
              <CardBody>
                <Stat>
                  <StatLabel>Energy Band</StatLabel>
                  <StatNumber>
                    <Badge colorScheme='green' fontSize='2xl' p={2}>
                      {propertyData.myHome.energyEfficiency.band}
                    </Badge>
                  </StatNumber>
                  <StatHelpText>
                    Yearly Cost: {propertyData.myHome.energyEfficiency.yearCost}
                  </StatHelpText>
                </Stat>
              </CardBody>
            </Card>

            <Card variant='outline'>
              <CardHeader>
                <Heading size='md'>Council Tax</Heading>
              </CardHeader>
              <CardBody>
                <Stat>
                  <StatLabel>Council Tax Band</StatLabel>
                  <StatNumber>
                    <Badge colorScheme='purple' fontSize='2xl' p={2}>
                      {propertyData.myHome.councilTax.band}
                    </Badge>
                  </StatNumber>
                  <StatHelpText>Annual Cost: {propertyData.myHome.councilTax.price}</StatHelpText>
                </Stat>
              </CardBody>
            </Card>
          </SimpleGrid>

          {/* House Prices */}
          <Card variant='outline'>
            <CardHeader>
              <Heading size='md'>House Prices</Heading>
            </CardHeader>
            <CardBody>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
                <Stat>
                  <StatLabel>Average Price</StatLabel>
                  <StatNumber>{propertyData.myArea.housePrices.average}</StatNumber>
                </Stat>
                <Stat>
                  <StatLabel>Price Trend</StatLabel>
                  <StatNumber>
                    <Badge
                      colorScheme={
                        propertyData.myArea.housePrices.trend.includes('+') ? 'green' : 'red'
                      }
                      fontSize='lg'
                    >
                      {propertyData.myArea.housePrices.trend}
                    </Badge>
                  </StatNumber>
                </Stat>
              </SimpleGrid>
            </CardBody>
          </Card>
        </VStack>
      </Container>
    </Box>
  );
}

export default Details;
